import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadCreditStat),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadPlanData),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadPromotionData),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doLoadCardData),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(doSelectPlan),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSaga),
    _marked7 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSaga);

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { push as updatePath } from 'react-router-redux';
import { all, call, fork, put, spawn, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import Base64Deriver from 'derivers/Base64';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { isEmpty } from 'helpers/verify';
import { msaCreditStatById, plansByMsa, promotionByAlias } from 'redux/saga/entities/bound';
import { getMsa } from 'containers/LocationModal/location.saga';
export var loadCardData = function loadCardData(plansModuleConfig) {
  return {
    type: 'PLAN_SELECTION_LOAD_CARD_DATA',
    plansModuleConfig: plansModuleConfig
  };
};
export var selectPlan = function selectPlan(itemType, itemId) {
  return {
    type: 'PLAN_SELECTION_SELECT_PLAN',
    itemType: itemType,
    itemId: itemId
  };
};
export function doLoadCreditStat(client, msa) {
  return regeneratorRuntime.wrap(function doLoadCreditStat$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return call(fetchEntityIfNeeded, msaCreditStatById, [client, msa.id]);

        case 3:
          _context.next = 8;
          break;

        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          logger.warn("Failed to find credit stat for msa [".concat(msa.id, "]"), _context.t0);

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 5]]);
}
export function doLoadPlanData(client, msa) {
  return regeneratorRuntime.wrap(function doLoadPlanData$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return call(fetchEntityIfNeeded, plansByMsa, [client, msa.id]);

        case 3:
          _context2.next = 8;
          break;

        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2["catch"](0);
          logger.warn("Failed to find plans for msa [".concat(msa.id, "]"), _context2.t0);

        case 8:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[0, 5]]);
}
export function doLoadPromotionData(client, msa, promotionAlias) {
  return regeneratorRuntime.wrap(function doLoadPromotionData$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;
          _context3.next = 3;
          return call(fetchEntityIfNeeded, promotionByAlias, [client, promotionAlias, msa.id]);

        case 3:
          _context3.next = 8;
          break;

        case 5:
          _context3.prev = 5;
          _context3.t0 = _context3["catch"](0);
          logger.warn("Failed to find promotion for alias [".concat(promotionAlias, "] in msa [").concat(msa.id, "]"), _context3.t0);

        case 8:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[0, 5]]);
}
export function doLoadCardData(client, _ref) {
  var plansModuleConfig, _ref2, moduleType, promotionAlias, msa;

  return regeneratorRuntime.wrap(function doLoadCardData$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          plansModuleConfig = _ref.plansModuleConfig;
          _ref2 = plansModuleConfig || {}, moduleType = _ref2.type, promotionAlias = _ref2.promotionAlias;
          _context4.next = 4;
          return call(getMsa, client);

        case 4:
          msa = _context4.sent;

          if (!isEmpty(msa)) {
            _context4.next = 7;
            break;
          }

          return _context4.abrupt("return");

        case 7:
          _context4.next = 9;
          return all([call(doLoadCreditStat, client, msa), moduleType === 'checkoutPlansModuleType' && call(doLoadPlanData, client, msa), moduleType === 'promotionPlansModuleType' && call(doLoadPromotionData, client, msa, promotionAlias)].filter(Boolean));

        case 9:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4);
}
export function doSelectPlan(client, _ref3) {
  var itemType, itemId;
  return regeneratorRuntime.wrap(function doSelectPlan$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          itemType = _ref3.itemType, itemId = _ref3.itemId;

          if (!(!itemId || !itemType)) {
            _context5.next = 3;
            break;
          }

          return _context5.abrupt("return");

        case 3:
          _context5.next = 5;
          return spawn(trackOptimizelyEvent, 'successful_plan_selection');

        case 5:
          _context5.next = 7;
          return put(updatePath("/signup/".concat(itemType, "/").concat(Base64Deriver.encode(itemId))));

        case 7:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function loadSaga(client, props) {
  return regeneratorRuntime.wrap(function loadSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return call(doLoadCardData, client, {
            plansModuleConfig: props.plansModuleType
          });

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}
export function watchSaga(client) {
  return regeneratorRuntime.wrap(function watchSaga$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return fork(takeEvery, loadCardData().type, doLoadCardData, client);

        case 2:
          _context7.next = 4;
          return fork(takeEvery, selectPlan().type, doSelectPlan, client);

        case 4:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}